import * as React from "react";

function SvgKeenIo(props, ref) {
  return (
    <svg
      viewBox="0 0 147.8 128"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#00afd7"
        d="M133.8 103.7H70.4l7-12.3h35.2L66.9 12.1l7-12.1z"
      />
      <path fill="#7dcc77" d="M59.9 24.3l31.6 54.9H77.4L59.8 48.8 14 128H0z" />
      <path fill="#f35757" d="M59.8 73.1l7.1 12.2-17.6 30.6h91.5l7 12.1H28z" />
    </svg>
  );
}

export default React.forwardRef(SvgKeenIo);
